import {Field} from 'formik';

import {
    FormikTextarea,
    FormikTextInput,
    PlatformFieldset
} from '@flexinet/ui-components';


export const FormComponent = () => {

    return (
        <PlatformFieldset legend={'Application Details'}>
            <Field
                name='name'
                label='Name'
                description='Please enter the application name'
                component={FormikTextInput}
                withAsterisk
                my={'xl'}
            />

            <Field
                name='description'
                label='Description'
                description='Please enter application description'
                component={FormikTextarea}
                my={'xl'}
            />

            <Field
                name='url'
                label='URL'
                description='Please enter application url'
                component={FormikTextInput}
                my={'xl'}
            />

            <Field
                name='email'
                label='Email'
                description='Please enter application email'
                component={FormikTextInput}
                my={'xl'}
            />

            <Field
                name='phone'
                label='Phone'
                description='Please enter application phone number'
                component={FormikTextInput}
                my={'xl'}
            />

            <Field
                name='logoUrl'
                label='Logo URL'
                description='Please enter logo url'
                component={FormikTextInput}
                my={'xl'}
            />

        </PlatformFieldset>
    );
};
